<div mat-dialog-title class="dialog-title">
    <table *ngIf="!isMobile()">
        <tr>
            <td>
                <h4>Nro. Orden de compra</h4>
    </table>

    <table *ngIf="isMobile()">
        <tr>
            <td>
                <h6>Nro. Orden de compra</h6>
    </table>
    <button style="background-color: transparent; color:#10384f;" [disabled]="form.invalid" mat-mini-fab
        aria-label="Salir" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="form">
        <div class="container-fluid">
            <div class="row align-items-center">

                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.NroOC}}</mat-label>
                        <input matInput formControlName="nroOC" type="text">

                        <!-- <mat-error
                            *ngIf="required && (form.get('comentarioLogAutorizacion').hasError('required')) && form.get('comentarioLogAutorizacion').touched">
                            {{Validaciones.Comentario}}
                        </mat-error> -->

                    </mat-form-field>
                </div>
            </div>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button (click)="aceptar()" [disabled]="form.invalid" mat-flat-button color="accent">Aceptar</button>
</mat-dialog-actions>